























import {
  Component,
  Vue,
} from 'vue-property-decorator';
import GenericButton from '@/components/GenericButton.vue';
import {Getter, Mutation} from 'vuex-class';

@Component({
  components: {
    GenericButton,
  },
})
export default class NotFound extends Vue {
  @Mutation private fullReset!: any;
  @Getter private login: any;

  private setOrgAndRedirect() {
    this.$router.push('/login');
    this.fullReset();
  }
}
